import { LegalPage } from "@/components/LegalPage";
import { TERMS_SECTIONS } from "@/data/legal";

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      title="Terms of Service"
      intro="These terms govern your use of Clawius and any dog training enrollment you submit."
      sections={TERMS_SECTIONS}
    />
  );
}
